// 补零
export function toDou (i) {
  return i < 10 ? `0${i}` : i
}

// 获取位置
export function getElemPos (obj) {
  let pos = {
    top: 0,
    left: 0
  }

  if (obj.offsetParent) {
    while (obj.offsetParent) {
      pos.top += obj.offsetTop
      pos.left += obj.offsetLeft
      obj = obj.offsetParent
    }
  } else if (obj.x) {
    pos.left += obj.x
  } else if (obj.x) {
    pos.top += obj.y
  }
  return {x: pos.left, y: pos.top}
}

// 深度克隆对象
export function deepClone (obj) {
  let newObj = obj instanceof Array ? [] : {}
  for (let i in obj) {
    newObj[i] = typeof obj[i] === 'object' && obj[i] !== null ? deepClone(obj[i]) : obj[i]
  }
  return newObj
}



function formatDate (date) {
  if (date) {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    return year + '-' + month.toString().padStart(2, '0') + '-' + day.toString().padStart(2, '0')
  } else {
    return ''
  }
}
//时分秒毫秒
function formatDatehms (date) {
  if (date) {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    let milliseconds = date.getMilliseconds();
    if(milliseconds<10){
      milliseconds += "00"
    }else if(milliseconds<100){
      milliseconds += "0"
    }
    return hours.toString().padStart(2, '0') + ":" + minutes.toString().padStart(2, '0') + ":" + seconds.toString().padStart(2, '0') + "."  + milliseconds.toString()
  } else {
    return ''
  }
}

//年月日时分秒
function formatDateAll (date) {
  var timeSpan = date.replace('Date','').replace('(','').replace(')','').replace('-','').replace(/\//g,'');
  var dates = new Date(parseInt(timeSpan));
  if (dates) {
    const year = dates.getFullYear()
    const month = dates.getMonth() + 1
    const day = dates.getDate()
    const hours = dates.getHours();
    const minutes = dates.getMinutes();
    const seconds = dates.getSeconds();
    return  year + '-' + month.toString().padStart(2, '0') + '-' + day.toString().padStart(2, '0') + " "+ hours.toString().padStart(2, '0') + ":" + minutes.toString().padStart(2, '0') + ":" + seconds.toString().padStart(2, '0')
  } else {
    return ''
  }
}

//年月日
function formatDateymd (date) {
  var timeSpan = date.replace('Date','').replace('(','').replace(')','').replace('-','').replace(/\//g,'');
  var dates = new Date(parseInt(timeSpan));
  if (dates) {
    const year = dates.getFullYear()
    const month = dates.getMonth() + 1
    const day = dates.getDate()
    // const hours = dates.getHours();
    // const minutes = dates.getMinutes();
    // const seconds = dates.getSeconds();
    return  year + '-' + month.toString().padStart(2, '0') + '-' + day.toString().padStart(2, '0');
  } else {
    return ''
  }
}




export { formatDate }
export { formatDatehms }
export { formatDateAll }
export { formatDateymd }



// WEBPACK FOOTER //
// ./src/common/js/common.js